"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginBodyToJSON = exports.LoginBodyFromJSONTyped = exports.LoginBodyFromJSON = void 0;
function LoginBodyFromJSON(json) {
    return LoginBodyFromJSONTyped(json, false);
}
exports.LoginBodyFromJSON = LoginBodyFromJSON;
function LoginBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userName': json['userName'],
        'password': json['password'],
    };
}
exports.LoginBodyFromJSONTyped = LoginBodyFromJSONTyped;
function LoginBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userName': value.userName,
        'password': value.password,
    };
}
exports.LoginBodyToJSON = LoginBodyToJSON;
